/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_BodyInputs */

const en_services_svc_save_body = /** @type {(inputs: Services_Svc_Save_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer questions, follow-ups, documents, CRM updates and reports. The system works from your approved sources, prepares the next step and shows where each answer came from. A person approves what leaves the business.`)
};

const lv_services_svc_save_body = /** @type {(inputs: Services_Svc_Save_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klientu jautājumi, atgādinājumi, dokumenti, CRM atjaunināšana un atskaites. Sistēma strādā ar Jūsu apstiprinātiem avotiem, sagatavo nākamo soli un parāda, no kurienes nāk katra atbilde. To, kas atstāj uzņēmumu, apstiprina cilvēks.`)
};

/**
* | output |
* | --- |
* | "Customer questions, follow-ups, documents, CRM updates and reports. The system works from your approved sources, prepares the next step and shows where each ..." |
*
* @param {Services_Svc_Save_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_body = /** @type {((inputs?: Services_Svc_Save_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_body(inputs)
	return en_services_svc_save_body(inputs)
});